import { create } from 'zustand';
import { persist } from 'zustand/middleware';
function applyTheme(theme) {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
    root.style.colorScheme = theme;
}
export const useThemeStore = create()(persist((set, get) => ({
    theme: 'light',
    resolvedTheme: 'light',
    setTheme: (theme) => {
        applyTheme(theme);
        set({ theme, resolvedTheme: theme });
    },
    initTheme: () => {
        const { theme } = get();
        applyTheme(theme);
        set({ resolvedTheme: theme });
    },
    toggleTheme: () => {
        const { resolvedTheme } = get();
        const newTheme = resolvedTheme === 'light' ? 'dark' : 'light';
        applyTheme(newTheme);
        set({ theme: newTheme, resolvedTheme: newTheme });
    },
}), {
    name: 'paathshaala-theme',
}));
